// ** Reactstrap Imports
import { MoreVertical, Trash2, Edit2, Copy } from 'react-feather';
import {
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
// ** Renders Role Columns
const statusObj = {
  active: 'light-success',
  inactive: 'light-secondary'
};

const renderPillar = (row) => {
  const options = new Map();
  const typeColor = {
    primary: '#7139F0',
    secondary: '#EFE8FF',
    text: 'Premium'
  };

  const typeName = {
    emotions: 'Emociones',
    relations: 'Relaciones',
    selfEsteem: 'Amor Propio',
    purpose: 'Sentido de Vida',
    transformation: 'Transformacion'
  };

  const formatPillars = () => {
    Object.keys(row.pillars).map((key) => {
      const item = row.pillars[key];
      if (item >= 1) {
        options.set(key, item);
      }
    });

    return [...options.entries()].map(([name, value], idx) => (
      <div
        key={idx}
        style={{
          color: typeColor.primary,
          background: `${typeColor.secondary} 0% 0% no-repeat padding-box`,
          padding: '2.5px 16px',
          borderRadius: '11px',
          fontWeight: 'bold',
          marginBottom: 5,
          fontSize: 10
        }}
      >
        {typeName[name]} {value}
      </div>
    ));
  };

  return (
    <span className="text-left d-flex flex-column h-100">
      {formatPillars()}
    </span>
  );
};

const ActivityName = ({ item, _data }) => {
  const name = _data.get(item);

  return (
    <div className="d-flex justify-content-left align-items-center">
      <div className="d-flex flex-column">
        <span className="fw-bolder">{name?.label || ''}</span>
      </div>
    </div>
  );
};

export const columns = ({ _data, handleDelete, navigate, duplicateEpisode }) => [
  {
    name: 'PORTADA',
    sortable: false,
    minWidth: '10px',
    selector: (row) => row.cover,
    cell: (row) => <img width={45} height={45} src={row.cover} />
  },
  {
    name: 'NOMBRE',
    sortable: true,
    minWidth: '300px',
    sortField: 'name',
    selector: (row) => row.title,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.title}</span>
        </div>
      </div>
    )
  },
  {
    name: 'ACTIVIDAD',
    sortable: true,
    minWidth: '172px',
    sortField: 'role',
    selector: (row) => row.activity,
    cell: (row) => <ActivityName item={row.activity} _data={_data} />
  },
  {
    name: 'Pilar',
    sortable: true,
    minWidth: '200px',
    sortField: 'pillars',
    selector: (row) => row.pillars,
    cell: (row) => renderPillar(row),
    conditionalCellStyles: [
      {
        when: (row) => {
          let amount = 0;
          Object.keys(row.pillars).map((key) => {
            const item = row.pillars[key];
            if (item >= 1) {
              amount = amount + 1;
            }
          });
          return amount === 1;
        },
        style: {
          height: '100%'
        }
      },
      {
        when: (row) => {
          let amount = 0;
          Object.keys(row.pillars).map((key) => {
            const item = row.pillars[key];
            if (item >= 1) {
              amount = amount + 1;
            }
          });
          return amount === 2;
        },
        style: {
          height: '100%',
          minHeight: '40px'
        }
      },
      {
        when: (row) => {
          let amount = 0;
          Object.keys(row.pillars).map((key) => {
            const item = row.pillars[key];
            if (item >= 1) {
              amount = amount + 1;
            }
          });
          return amount === 3;
        },
        style: {
          height: '100%',
          minHeight: '80px'
        }
      },
      {
        when: (row) => {
          let amount = 0;
          Object.keys(row.pillars).map((key) => {
            const item = row.pillars[key];
            if (item >= 1) {
              amount = amount + 1;
            }
          });
          return amount === 4;
        },
        style: {
          height: '100%',
          minHeight: '100px'
        }
      },
      {
        when: (row) => {
          let amount = 0;
          Object.keys(row.pillars).map((key) => {
            const item = row.pillars[key];
            if (item >= 1) {
              amount = amount + 1;
            }
          });
          return amount === 5;
        },
        style: {
          height: '100%',
          minHeight: '130px'
        }
      }
    ]
  },
  {
    name: 'Estado',
    minWidth: '20px',
    sortable: true,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.status ? statusObj.active : statusObj.inactive}
        pill
      >
        {row.status ? 'Activo' : row.draf ? 'Borrador' : 'Inactivo'}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '100px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/roads/episodes/edit/${row._id}`);
              }}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleDelete(row._id)}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => duplicateEpisode(row)}
            >
              <Copy size={14} className="me-50" />
              <span className="align-middle">Duplicar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
